import React, { useEffect } from "react";
import { Redirect, useLocalSearchParams, usePathname } from "expo-router";
import * as Sentry from "@sentry/react-native";
import { Linking } from "react-native";

// This is needed to support deep-linking. kai://app will redirect to the main app route.

export default function AppRoute(): React.JSX.Element {
  const params = useLocalSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    const handleDeepLink = async (): Promise<void> => {
      try {
        const initialUrl = await Linking.getInitialURL();
        Sentry.logger.info("kai://app route accessed", {
          initialUrl,
          pathname,
          params,
        });
      } catch (error) {
        Sentry.captureException(error);
      }
    };
    handleDeepLink();
  }, []);

  return <Redirect href="/" />;
}
